import { useMutation } from '@tanstack/react-query'
import { sendTypeTestAnswersApi } from '@/api/typeTestApi'
import type { TypeTestDiagnosisRequest } from '@/api/model/typeTestType'

/** 타입 테스트 답변 전송 */
export const useSendTypeTestAnswersMutation = () => {
  return useMutation({
    mutationFn: (request: TypeTestDiagnosisRequest) => sendTypeTestAnswersApi(request)
  })
}
